import { render, staticRenderFns } from "./EditPersonalInfoPanel.vue?vue&type=template&id=4472f55a&lang=pug&"
import script from "./EditPersonalInfoPanel.vue?vue&type=script&lang=js&"
export * from "./EditPersonalInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonalInfoPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports